import { createApiMutationHook, IApiMutationFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { ILocationResource } from "../types";

export type ILocationDeleteMutationParameters = {
    location: RelationalValue<ILocationResource>;
};

export type ILocationDeleteMutationResult = void;

export const locationDeleteMutation: IApiMutationFunction<ILocationDeleteMutationParameters> = ({ location }) => {
    return {
        method: "DELETE",
        url: `/locations/${mapRelationalValue(location)}`,
    };
};

export const useLocationDeleteMutation = createApiMutationHook<
    ILocationDeleteMutationParameters,
    ILocationDeleteMutationResult
>(locationDeleteMutation);
